import Vue from "vue";

/**
 * 利用 vue 实例实现的简易事件发布订阅
 */
export const eventHub = new Vue();
